import { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui";
import { ReactNode } from "react";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description: string;
  action?: {
    label: string;
    icon?: LucideIcon;
    onClick: () => void;
  };
  children?: ReactNode;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  children,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-8 px-6 text-center">
      {Icon && (
        <div className="w-[52px] h-[52px] rounded-[14px] bg-white/[0.03] border border-border flex items-center justify-center mb-4">
          <Icon className="w-6 h-6 text-muted-foreground" />
        </div>
      )}
      <h3 className="font-display text-lg font-semibold tracking-[-0.025em] text-muted-foreground mb-2">
        {title}
      </h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-xs leading-[1.55]">
        {description}
      </p>
      {action && (
        <Button onClick={action.onClick} leftIcon={action.icon}>
          {action.label}
        </Button>
      )}
      {children}
    </div>
  );
}
